
    import { Component } from 'vue-property-decorator';
    import Button from '@ve/components/button/common/Button';

    @Component({
        name: 'ButtonDesktop',
    })
    export default class extends Button {
    }
